export default "__VITE_ASSET__DOZ9MIf7__"